import React from 'react'
import Link from 'gatsby-link'
import Navigoat from '../layouts/navigoat.js'
import SkyLight from 'react-skylight';

import {Col, Row} from 'react-bootstrap'


export default class ProjectPage extends React.Component {

  render() {
    const {title, authors, paper_title, abstract, paper_linky, img_caption, paper_img, video_linky, bibtex} = this.props;
    var youtube_linky = null;

    let video_link_el = null;
    let video_frame = null;
    if (video_linky != ''){
      youtube_linky = video_linky.split('/')
      youtube_linky = 'https://youtu.be/' + youtube_linky[youtube_linky.length-1]

      video_link_el =   <a className="mat-link" href={youtube_linky}>
          Video
          <span className="glyphicon glyphicon-facetime-video right-glyph"></span>
        </a>

      video_frame =  <div>
        <div className="proj-heading" > Video</div>
        <iframe className='fitted-frame'
                src={video_linky}
                frameBorder="0"
                allowFullScreen>
        </iframe>
        </div>
    }


    return (
      <Row>
        <SkyLight
          hideOnOverlayClicked
          beforeOpen={this._executeBeforeModalOpen}
          dialogStyles={ {height:'auto'} }
          ref="simpleDialog"
          title={title}>
          <div id="prewrap">
            {bibtex}
          </div>
        </SkyLight>
        <Col md={3}></Col>
        <Col md={6}>
          <h2> {title} </h2>

          <div className="proj-heading"> Paper</div>
          <span className="paper-title-text">
            {paper_title}
          </span>
          <br/>
          <span className="author-text">
            {authors}
          </span>

          <div className="project-img-div">
            <img src={paper_img} alt="Crown Jewel Figure" />
            <div className="caption-text"> {img_caption} </div>
          </div>

          <div className="proj-heading" > Abstract</div>
          {abstract}

          <div className="proj-heading" > Materials</div>
          <a className="mat-link" href={paper_linky}>
            PDF
            <span className="glyphicon glyphicon-download-alt right-glyph"></span>
          </a>
          <span className="mat-link" id="fake-link" onClick={() => this.refs.simpleDialog.show()}>
            BibTeX
            <span className="glyphicon glyphicon-education right-glyph"></span>
          </span>

          {video_link_el}

          {video_frame}


        </Col>
        <Col md={3}></Col>
      </Row>
    );
  }
};



// WEBPACK FOOTER //
// ./src/layouts/pr_page.js